import React, { useEffect } from 'react'

import { useKeyCloak } from '@/hooks/useKeyCloak'
import { ROLE_STATUS } from '@/hooks/useKeyCloak/types'

import { AnimatePresence } from 'framer-motion'
import mixpanel from 'mixpanel-browser'

import { PageLoader } from '@/components/ui'
import { InvalidRole } from '@/components/ui'

import { AnimatedDiv } from './animatedDiv'

export function requireAuth<PT>(Component: React.ComponentType<PT>) {
  return function (props: PT) {
    const {
      isKcInitilised,
      isResolvingRedirect,
      logIn,
      isValidLogin,
      roleStatus,
    } = useKeyCloak()

    useEffect(() => {
      if (!isValidLogin && isKcInitilised && !isResolvingRedirect) {
        mixpanel.track('Page View: LoginForm')
        logIn()
      }
    }, [isKcInitilised, isResolvingRedirect, isValidLogin])

    return (
      <AnimatePresence exitBeforeEnter initial={false}>
        {!isValidLogin || isResolvingRedirect ? (
          <AnimatedDiv>
            <PageLoader />
          </AnimatedDiv>
        ) : isValidLogin && roleStatus !== ROLE_STATUS.INVALID ? (
          <AnimatedDiv>
            <Component {...props} />
          </AnimatedDiv>
        ) : (
          <AnimatedDiv>
            <InvalidRole />
          </AnimatedDiv>
        )}
      </AnimatePresence>
    )
  }
}
